import { previewActions } from "../action/types";

const initialState = {
	isPreview: false,
	previewData: null,
};

const serviceLinkPreviewReducer = (state = initialState, action) => {
	switch (action.type) {
		case previewActions.SERVICE_LINK_PREVIEW_ADD: {
			const {  previewData } = action.payload;
			const object = {
                ...state,
				isPreview: true,
				previewData,
            }
			return object;
		}
		case previewActions.SERVICE_LINK_PREVIEW_CLEAR: {
			const object = {
                ...state,
				isPreview: false,
				previewData: null,
            }
			return object;
		}

		default:
			return state;
	}
};

export default serviceLinkPreviewReducer;